(() => {
  const mobile = matchMedia('(max-width: 989px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.cb-regular-help-button, .cb-option-help-button';
  const states = new Map();
  let frame = 0;
  const visible = button => {
    if (!button.isConnected || document.hidden || !mobile.matches || reduced.matches) return false;
    const rect = button.getBoundingClientRect();
    const viewport = window.visualViewport;
    const top = viewport?.offsetTop || 0;
    let bottom = viewport ? top + viewport.height : innerHeight;
    const bar = document.querySelector('.product-sticky-bar');
    if (bar && getComputedStyle(bar).position === 'fixed') {
      const bounds = bar.getBoundingClientRect();
      if (bounds.height && bounds.top < bottom) bottom = bounds.top;
    }
    if (!rect.width || !rect.height || rect.top < top || rect.bottom > bottom || rect.left < 0 || rect.right > innerWidth) return false;
    const style = getComputedStyle(button);
    if (style.visibility !== 'visible' || Number(style.opacity) === 0) return false;
    return button.contains(document.elementFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2));
  };
  const cancel = (button, state) => {
    clearTimeout(state.timer);
    state.timer = null;
    button.classList.remove('cb-help-in-view');
  };
  const sync = () => {
    frame = 0;
    for (const [button, state] of states) {
      if (!button.isConnected) {
        cancel(button, state);
        observer.unobserve(button);
        states.delete(button);
        continue;
      }
      if (!visible(button)) {
        cancel(button, state);
      } else if (!state.played && state.timer === null) {
        state.timer = setTimeout(() => {
          state.timer = null;
          if (!visible(button)) return;
          state.played = true;
          button.classList.add('cb-help-in-view');
        }, 500);
      }
    }
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(sync);
  };
  const observer = new IntersectionObserver(schedule, { threshold: [0, 1] });
  const register = () => {
    document.querySelectorAll(selector).forEach(button => {
      if (states.has(button)) return;
      const state = { timer: null, played: false };
      states.set(button, state);
      const engaged = () => {
        state.played = true;
        cancel(button, state);
      };
      button.addEventListener('pointerdown', engaged);
      button.addEventListener('focusin', engaged);
      observer.observe(button);
    });
    schedule();
  };
  new MutationObserver(register).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  document.addEventListener('visibilitychange', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  reduced.addEventListener('change', schedule);
  register();
})();
